module.exports = __webpack_public_path__ + "img/pro_02.9393c4c4.jpg";